import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SessionInterceptorService } from './services/session-interceptor.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { IdleConfigService } from './services/idle-config.service';
import { SessionExpiryPopupComponent } from './components/session-expiry-popup/session-expiry-popup.component';
import { SharedModule } from '../shared/shared.module';

const SessionComponents = [
  { name: 'SessionExpiryPopup', type: SessionExpiryPopupComponent }
];

@NgModule({
  declarations: [SessionExpiryPopupComponent],
  imports: [CommonModule, SharedModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SessionInterceptorService,
      multi: true
    }
  ]
})
export class SessionModule {
  constructor(idleConfigService: IdleConfigService) {
    idleConfigService.configIdle();
  }
}

export { SessionComponents };
